import React from "react";
import ReactDOM from "react-dom";
import AppRouter from "./App";
import "./styles/global.css";

ReactDOM.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>,
  document.getElementById("root")
);
